import elementResizeEvent from 'element-resize-event'
import Vue from 'vue'

Vue.directive('resize', {
    inserted(el, binding) {
        let fn = binding.value['listener']
        if (!fn) {
            return
        }
        elementResizeEvent(el, fn)
    },
    unbind(el) {
        elementResizeEvent.unbind(el)
    }
})
